import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { epicsErrorHandler } from '../../../epics'

import {
  fetchGroupSettingsDataError,
  fetchGroupSettingsDataSuccess,
  saveGroupSettingsError,
  saveGroupSettingsSuccess,
  saveInfoFormError,
  saveInfoFormSuccess,
} from './actions'
import {
  FETCH_SETTINGS_REQUEST_ASYNC,
  SAVE_INFO_FORM_ASYNC,
  SAVE_SETTINGS_REQUEST_ASYNC,
} from './constants'

const saveInfoFormDataEpic = (action$, store, { api }) =>
  action$.ofType(SAVE_INFO_FORM_ASYNC.INITIATE).mergeMap(() =>
    api.groupSettings
      .saveInfoForm(store.getState().partnerOptions.selectedCompany?.value, {
        name: store.getState().groupsettings.wizard.data.name,
        description: store.getState().groupsettings.wizard.data.description,
        id: store.getState().groupsettings.wizard.data.id,
      })
      .map((response) => saveInfoFormSuccess(response?.response))
      .catch((error) => Observable.of(epicsErrorHandler(saveInfoFormError, error)))
      .takeUntil(action$.ofType(FETCH_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

const fetchGroupSettingsDataEpic = (action$, store, { api }) =>
  action$.ofType(FETCH_SETTINGS_REQUEST_ASYNC.INITIATE, SAVE_INFO_FORM_ASYNC.SUCCESS).mergeMap(() =>
    api.groupSettings
      .getGroupSettingsData(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().groupsettings.wizard.data.id
      )
      .map((response) => fetchGroupSettingsDataSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchGroupSettingsDataError, error)))
      .takeUntil(action$.ofType(FETCH_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

const updateGroupSettingsDataEpic = (action$, store, { api }) =>
  action$.ofType(SAVE_SETTINGS_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.groupSettings
      .updateGroupSettingsData(store.getState().partnerOptions.selectedCompany?.value, {
        groupSettingsId: store.getState().groupsettings.wizard.data.id,
        incidentResponse: store.getState().settings.incidentResponse.self.data,
        impersonationProtection: store.getState().settings.mailboxProtection.self.data,
        landingPages: store.getState().settings.mailboxProtection.landings.data,
        endUserAlerts: store.getState().groupsettings.wizard.endUserAlerts,
        notificationsLogoTemplate:
          store.getState().settings.notifications.logo.data.notificationsLogoTemplate,
        isDefault: store.getState().groupsettings.wizard.isDefault,
      })
      .map((response) => saveGroupSettingsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(saveGroupSettingsError, error)))
      .takeUntil(action$.ofType(SAVE_SETTINGS_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(
  saveInfoFormDataEpic,
  fetchGroupSettingsDataEpic,
  updateGroupSettingsDataEpic
)
